import { render, staticRenderFns } from "./InitAppointmentForm.vue?vue&type=template&id=5cc5dbdc&"
import script from "./InitAppointmentForm.vue?vue&type=script&lang=js&"
export * from "./InitAppointmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports